export default function WhyChoose() {
  const features = [
    {
      icon: 'ri-home-heart-line',
      title: 'Family Owned',
      description: 'Personalized service and commitment to excellence since 1996',
    },
    {
      icon: 'ri-time-line',
      title: 'Fast Turnaround',
      description: 'Quick response times and efficient project completion',
    },
    {
      icon: 'ri-file-text-line',
      title: 'Clear Reporting',
      description: 'Easy-to-understand reports with actionable recommendations',
    },
    {
      icon: 'ri-team-line',
      title: 'Experienced Team',
      description: '25+ years of field-tested environmental consulting',
    },
  ];

  return (
    <section id="why-choose" className="py-12 sm:py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold mb-3 sm:mb-4">Why Choose LCA Group</h2>
          <p className="text-base sm:text-lg text-gray-300 max-w-3xl mx-auto px-4">
            Trusted by property managers, housing authorities, and developers nationwide
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white/5 backdrop-blur-sm rounded-xl p-6 sm:p-8 hover:bg-white/10 transition-all duration-300 border border-white/10"
            >
              <div className="w-14 h-14 sm:w-16 sm:h-16 bg-[#f59e0b] rounded-xl flex items-center justify-center mx-auto mb-5 sm:mb-6">
                <i className={`${feature.icon} text-2xl sm:text-3xl text-white`}></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold mb-2 sm:mb-3 text-center">{feature.title}</h3>
              <p className="text-sm sm:text-base text-gray-300 text-center leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 sm:mt-16 text-center px-4">
          <div className="inline-flex flex-col sm:flex-row items-center bg-white/5 backdrop-blur-sm rounded-2xl px-6 sm:px-8 py-4 sm:py-4 border border-white/10">
            <i className="ri-award-line text-3xl text-[#f59e0b] mb-3 sm:mb-0 sm:mr-4"></i>
            <div className="text-center sm:text-left">
              <div className="font-bold text-base sm:text-lg">EPA Certified & State Licensed</div>
              <div className="text-gray-300 text-xs sm:text-sm">Fully accredited environmental consultants</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
